import React from 'react';

import {
  Box,
  Tooltip,
  Typography
} from '@mui/material';

import NA from './NA';

// A raw user-agent string is unreadable in a table cell and pushes every other
// column off screen. Reduce it to "<browser> · <platform>" and keep the full
// string on hover, so the cell stays scannable without losing detail.
const BROWSERS = [
  // order matters — Edge/Opera/Brave UAs also contain "Chrome"
  { label: 'Edge', re: /Edg(?:e|A|iOS)?\/([\d.]+)/ },
  { label: 'Opera', re: /OPR\/([\d.]+)/ },
  { label: 'Samsung Internet', re: /SamsungBrowser\/([\d.]+)/ },
  { label: 'Firefox', re: /Firefox\/([\d.]+)/ },
  { label: 'Chrome', re: /Chrome\/([\d.]+)/ },
  { label: 'Safari', re: /Version\/([\d.]+).*Safari/ },
];

const PLATFORMS = [
  { label: 'iPadOS', re: /iPad/ },
  { label: 'iOS', re: /iPhone|iPod/ },
  { label: 'Android', re: /Android(?:\s([\d.]+))?/ },
  { label: 'macOS', re: /Mac OS X/ },
  { label: 'Windows', re: /Windows NT/ },
  { label: 'Linux', re: /Linux/ },
];

export const summariseUserAgent = (userAgent) => {
  if (!userAgent) return null;

  let browser = null;
  for (const b of BROWSERS) {
    const m = userAgent.match(b.re);
    if (m) {
      // major version only — the full build number is noise here
      browser = m[1] ? `${b.label} ${m[1].split('.')[0]}` : b.label;
      break;
    }
  }

  let platform = null;
  for (const p of PLATFORMS) {
    if (p.re.test(userAgent)) {
      platform = p.label;
      break;
    }
  }

  if (!browser && !platform) {
    // non-browser client (curl, a mobile SDK, a bot) — show it truncated
    return userAgent.length > 40 ? `${userAgent.slice(0, 40)}…` : userAgent;
  }

  return [browser, platform].filter(Boolean).join(' · ');
};

const UserAgentCell = ({ userAgent }) => {
  const summary = summariseUserAgent(userAgent);

  if (!summary) return <NA />;

  return (
    <Tooltip title={userAgent}>
      <Box sx={{ maxWidth: "200px" }}>
        <Typography
          variant='body2'
          className="longText">
          {summary}
        </Typography>
      </Box>
    </Tooltip>
  )
}

export default UserAgentCell;
